export const MQTT_CSR = "MQTT";
export const TLS_CSR = "TLS";
export const SELF_MANAGED_CSR = "SELF_MANAGED"

export const MDCS_DEVICE = 'MDCS';
export const DAGW_DEVICE = 'DAGW';
export const TC_DEVICE = 'TC';
export const OTHER_DEVICE = 'OTHER';

export const DAGW_DEVICE_TYPE = 'DAGW2';
export const TC_DEVICE_TYPE = 'TC1';

export const RENEW_DAGW_MQTT_CERT_ACTION = 'attach';

export const MDCS_MQTT_CSR = `${MDCS_DEVICE}_${MQTT_CSR}`;
export const MDCS_TLS_CSR = `${MDCS_DEVICE}_${TLS_CSR}`;
export const DAGW_MQTT_CSR = `${DAGW_DEVICE}_${MQTT_CSR}`;

export const DEVICE_TYPES = [
    { label: "MDCS", value: MDCS_DEVICE },
    { label: "DAGW", value: DAGW_DEVICE },
    { label: "TC", value: TC_DEVICE },
    { label: "OTHER", value: OTHER_DEVICE },
]

export const MDCS_CSR_TYPES = [
    { label: "MQTT", value: MDCS_MQTT_CSR },
    { label: "TLS", value: MDCS_TLS_CSR },
]
export const DAGW_CSR_TYPES = [
    { label: "MQTT", value: `${DAGW_DEVICE}_${MQTT_CSR}` },
]
export const TC_CSR_TYPES = [
    { label: "MQTT", value: `${TC_DEVICE}_${MQTT_CSR}` },
]
export const OTHER_CSR_TYPES = [
    { label: "SELF MANAGED", value: SELF_MANAGED_CSR },
]

export const THIRD_PARTY_CERT = '3RD_PARTY';

export const UserRole = {
    ADMIN: "Admin",
    OPERATOR: "Operator",
    APPROVER: "Approver",
}

export const Status = {
    pending: 'pending',
    rejected: 'rejected',
    approved: 'approved',
    failed: 'failed',
}

export const Type = {
  register: 'register',
  renew: 'renew',
  revoke: 'revoke',
}
